//import React from 'react';
import React, { useState, useEffect } from 'react';
import AccountNavbar from './AccountNavbar';
import SectionHeader from './SectionHeader';
import AccountInfoCard from './AccountInfoCard';
import SecurityCard from './SecurityCard';
import MembershipCard from './MembershipCard';
import TableInfoCard from './TableInfoCard';
import { useAuth } from '../../context/AuthContext';

const AccountPage = () => {

  const [invoices, setInvoices] = useState([]);
  const [list, setList] = useState([]);
  const { user, setMembership, ensureMembership } = useAuth();

  useEffect(() => {
    if (!user?.email) return;
    let cancelled = false;

    const loadMembership = async () => {
      try {
        const data = await ensureMembership(user.email);
        if (cancelled || !data) return;
        setMembership(data);
        setList(data);
        const mapped = (data.paymentHistory || []).map((it) => ({
          date: it.payDate || it.createdAt || it.created || '',
          type: it.type || it.kind || 'Invoice',
          orderNumber: it.token || it.id || it.reference || '',
          membership: it.planName || it.product || 'Membership',
          amount: it.amount || it.total,
        }));
        setInvoices(mapped);
      } catch (err) {
        console.error('Error ensuring membership:', err);
      }
    };

    loadMembership();
    return () => { cancelled = true; };
  }, [user, ensureMembership, setMembership]);
  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8' }}>
      <AccountNavbar />

      <SectionHeader
        title="Account"
        description="This is the personal information you use to access and manage your account. You can also add a mobile phone number and secondary email for account security, recovery, and notifications."
      />
      <AccountInfoCard />

      <SectionHeader title="Sign in and security" />
      <SecurityCard />

      <SectionHeader title="Membership" />
      <MembershipCard invoce = {list}/>


      <SectionHeader
        title="Invoice and billing history"
        description="Review your billing history and manage your invoices."
      />
      <TableInfoCard invoices={invoices}/>
    </div>
  );
};

export default AccountPage;
